async function addCollectionPriceAttributesNew() {
    const config = { selectorCard: '.spf-product-card', selectorPrice: '.spf-product-card__price-wrapper', selectorQuickviewBtn: '.open-quick-view'};
    if (!config) return;

    if (!BSS_B2B.productMap) {
        BSS_B2B.productMap = new Map();
    }

    const productCache = BSS_B2B.productMap;
    const collectionProducts = BSS_B2B?.shopData?.collection || [];
    const cards = Array.from(document.querySelectorAll(config.selectorCard));

    const tasks = cards.map(async (card) => {
        const href = card.querySelector('a[href*="/products/"]')?.getAttribute('href');
        if (!href) return;

        const handle = href.split('/products/')[1]?.split('?')[0];
        const priceEl = card.querySelector(config.selectorPrice);
        const quickviewBtn = Array.from(card.querySelectorAll(config.selectorQuickviewBtn));

        if (!handle || !priceEl || priceEl.hasAttribute('bss-b2b-product-id')) return;

        let product = collectionProducts.find((p) => p.handle === handle) || productCache.get(handle);

        if (!product) {
            try {
                const res = await fetch(`/products/${handle}.js`);
                product = res.ok ? await res.json() : null;
                if (!product) return;
                productCache.set(handle, product);
            } catch (e) {
                BSS_B2B.logger?.warn?.(`[BSS B2B] fetch error: ${handle}`, e);
                return;
            }
        }
        
        card.setAttribute('bss-b2b-product-qb-id', product.id.toString());

        const existingQbTable = card.querySelector('.bss-b2b-qb-table');
        if (!existingQbTable) {
            const qbTableDiv = document.createElement('div');
            qbTableDiv.className = 'bss-b2b-qb-table';
            priceEl.parentNode?.insertBefore(qbTableDiv, priceEl.nextSibling);
        }

        priceEl.setAttribute('bss-b2b-product-id', product.id.toString());
        priceEl.setAttribute('bss-b2b-variant-id', product.variants?.[0]?.id?.toString() || '');
        priceEl.setAttribute('bss-b2b-product-price', '');
        priceEl.setAttribute('bss-b2b-collection-element', '');

        quickviewBtn.forEach((el) => el.setAttribute('bss-b2b-btn-quickview', ''));
    });

    await Promise.all(tasks);
    const configWithSearchBar = config;
    if (configWithSearchBar.selectorSearchBar) {
        const searchBarEl = document.querySelector(configWithSearchBar.selectorSearchBar);
        if (searchBarEl && !searchBarEl.classList.contains('bss-b2b-search-bar')) {
            searchBarEl.classList.add('bss-b2b-search-bar');
        }
    }
  await BSS_B2B.storage.productStorage.load(); 
  BSS_B2B.cp?.utils?.init();
  BSS_B2B?.observer?.productSubject?.notifyObserver('ProductMutate', 'ProductPriceMutate');
}

if (typeof BSS_B2B != undefined) {
  setTimeout(async () => {
    await addCollectionPriceAttributesNew();
  }, 4000);

  // fix quickview
  setTimeout(() => {
    const mutationObserver = new MutationObserver((recordList, observe) => {
      for (const record of recordList) {
        if (record.target.closest && record.target.closest("#gfqv-btn-wrap")) {
          document.dispatchEvent(new Event("bss_b2b:QuickviewLoaded"));
          break;
        }
      }
    });
    mutationObserver.observe(document, { childList: true, subtree: true });
  }, 1000);

  //fix filter search
  function setupMainCollection() {
    const mainCollection = document.querySelector("#gf-controls-container");
    if (!mainCollection) return;
  
    const mainObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.target.classList.contains("gf-summary")) {
          setTimeout(() =>{
            addCollectionPriceAttributesNew()
          }, 1000)
          break;
        }
      }
    });
  
    mainObserver.observe(mainCollection, {
      attributes: true,
      attributeFilter: ["class"],
      childList: true,
      subtree: true,
    });
  }

  setTimeout(setupMainCollection, 3000);

}






